import * as React from 'react';
import { Dialog, DialogType, DialogFooter } from '@fluentui/react/lib/Dialog';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { clearError } from '../actions/navigationWorker';

type Props = {
    error: string|Error;
    hide: boolean
}
export default function ErrorMessageOnPage({ hide, error }: Props) {
    if (hide === true) return null;

    const errorMessage = typeof(error) === "string" ? error : error.message;
    
    return (
        <Dialog
            hidden={false}
            onDismiss={clearError}
            dialogContentProps={{
                type: DialogType.normal,
                title: 'Error',
                showCloseButton: true
            }}
            modalProps={{
                isBlocking: false,
                styles: { main: { maxWidth: 450 } }
            }}
        >
            <div style={{ padding: '20px 0', fontSize: '14px', lineHeight: '1.5' }}>
                {errorMessage}
            </div>
            <DialogFooter>
                <PrimaryButton 
                    onClick={clearError} 
                    text="OK"
                    styles={{
                        root: {
                            backgroundColor: '#5D3FD6',
                            borderColor: '#5D3FD6'
                        },
                        rootHovered: {
                            backgroundColor: '#4A2FC7',
                            borderColor: '#4A2FC7'
                        }
                    }}
                />
            </DialogFooter>
        </Dialog>
    );
}
